
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.813 3l-.688.719-4.406 4.406L3 8.813 10.188 16l-5 5-.063.313-1.094 5.5-.312 1.468 1.469-.312 5.5-1.094.312-.063 5-5 7.156 7.157.688-.719 4.406-4.406.719-.688L21.812 16l4.938-4.938a4.102 4.102 0 000-5.812 4.11 4.11 0 00-2.906-1.219 4.11 4.11 0 00-2.907 1.219L16 10.188zm0 2.844l1.937 1.968-1.469 1.47 1.438 1.437 1.469-1.469 2.374 2.375-2.968 2.969-5.781-5.781zm15.03.125c.52 0 1.048.234 1.5.687.903.903.903 2.067 0 2.969l-.655.656-2.97-2.969.657-.656c.453-.453.95-.687 1.469-.687zm-3.53 2.75l2.968 2.969L11.188 23.78a6.98 6.98 0 00-2.97-2.968zm.093 8.687l2.375 2.375-1.5 1.5 1.438 1.438 1.5-1.5 1.906 1.906-3 3-5.719-5.719zm-13.468 5a4.968 4.968 0 012.656 2.657l-3.313.656z"}})])
          )
        }
      }
    